export const staticMessages = {
  mySpace: {
    tabs: ["profile", "activity"],
    activityTabs: ["posts", "followers", "following"],
  },
  calendar: {
    tabs: ["settings", "schedule"],
  },
};
